import { DOMAIN_TYPE } from '../constants';

const DOMAIN_NAME = 'loading';

export const UPDATE_LOADING_STATUS =
  `${DOMAIN_TYPE}/${DOMAIN_NAME}/UPDATE_LOADING_STATUS` as const;
